import { useLayoutEffect, useRef } from "react";
import { castsShadow } from "./ghost";
const isTransparent = (material) => Array.isArray(material) ? material.some((m) => m.transparent) : material.transparent;
function ShadowCasters({ children }) {
  const group = useRef(null);
  useLayoutEffect(() => {
    var _a;
    (_a = group.current) == null ? void 0 : _a.traverse((object) => {
      const mesh = object;
      if (!mesh.isMesh) return;
      mesh.castShadow = castsShadow({
        overlay: Boolean(mesh.userData.overlay),
        transparent: isTransparent(mesh.material)
      });
    });
  });
  return <group ref={group}>{children}</group>;
}
export {
  ShadowCasters
};
